import { getUserHasPremium } from '@griply/utils';
import { useUser } from 'shared/hooks/use-user';

export const useUserHasPremium = () => {
  const user = useUser();
  return getUserHasPremium(user);
};
